import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/contact.css';
import '../css/contactResponsive.css'
import ContactCard from '../../../../component-module/component-services/card/contact/ts/contactCard';
import { useCmsPage } from '../../../../context-module/context-configuration/auth-provider/appShell/appShellContent/appUseCntData';
import { ContactPageData } from './contactData';
import { API_ENDPOINTS } from '../../../../context-module/context-configuration/auth-provider/apiGroup/apiProvider';

const contactRouteMap: Record<number, string> = {
  1: '/contact/business-contact',
  2: '/contact/sales-contact',
  3: '/career',
};

export const mapContactCardsFromCMS = (
  lists: any[],
  navigate: (path: string) => void
) => {
  return lists.map((item) => ({
    title: item.title,
    description: item.description,
    buttonText: item.button.label,
    onButtonClick: () => navigate(contactRouteMap[item.id]),
  }));
};

const Contact = () => {
  const navigate = useNavigate();
  const { data } = useCmsPage<ContactPageData>(API_ENDPOINTS.ROUTE_URL.CONTACT);
  const dataContact = data?.contact?.cta?.[0]
  const contactSection = dataContact?.contactSection?.content?.[0].headerSection;
  const cmsLists = contactSection?.lists ?? [];
  const contactCards = mapContactCardsFromCMS(cmsLists, navigate);
  
  return (
    <section className="scl--web-page-contact-get-in-touch-section">
      <div className='scl--web-page-contact-contact-section'>
        {contactSection?.visible && 
          <div className="scl--web-page-contact-title-section">
            <div className="scl--web-page-contact-title-section-content">
              <h1 className="scl--web-page-contact-main-title">{contactSection?.title}</h1>
              <p className="scl--web-page-contact-subtitle">
                {contactSection?.description}
              </p>
            </div>
          </div>
        }

        {contactSection?.visible && 
          <div className="scl--web-page-contact-cards-wrapper">
            {contactCards?.map((card) => (
              <ContactCard
                key={card.title}
                title={card.title}
                description={card.description}
                buttonText={card.buttonText}
                onButtonClick={card.onButtonClick}
              />
            ))}
          </div>
        }
        
      </div>

    </section>

  );
};

export default Contact;
